import { IGetRequisicaoCompraByIdUseCase } from "../../../presentation/useCases/read/get_requisicao_compra_by_id_use_case";
import { RequisicaoCompra } from "../../models/requisicao_compra";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * GetRequisicaoCompraByIdUseCase
 */

export class GetRequisicaoCompraByIdUseCase implements IGetRequisicaoCompraByIdUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async getRequisicaoCompraById(
    idRequisicaoCompra: number | undefined,
  ): Promise<RequisicaoCompra> {
    if (idRequisicaoCompra === undefined) throw new Error('Falha ao obter id de requisição de produtos/serviço!');
    const result = await this.repository.getRequisicaoCompraById(
      idRequisicaoCompra,
    );
    if (result === null) throw new Error('Falha ao buscar requisição de produtos/serviços!');
    return result;
  }
}
